import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '@shared/auth/cognito';

export default function RequireAuth({ children }: PropsWithChildren) {
  const location = useLocation();

  if (!isAuthenticated()) {
    const returnTo = `${location.pathname}${location.search}${location.hash}` || '/';
    return <Navigate to="/login" replace state={{ returnTo }} />;
  }

  return <>{children}</>;
}
